module.exports = __webpack_public_path__ + "static/media/tick.7591f433.png";